import {Routes} from '@angular/router';
import {ProductDetailsComponent} from './container/product-details/product-details.component';
import {ProductsAndFilterComponent} from './container/products-and-filter/products-and-filter.component';
import {ProductWindowComponent} from './product-window/product-window.component';
import {WindowDetailsComponent} from './product-window/window-details/window-details.component';

export const routes: Routes = [
  {path: '', pathMatch: 'full', redirectTo: 'home'},
  {path: 'home', component: ProductsAndFilterComponent},
  {path: 'windows', component: ProductWindowComponent},
  {path: 'productDetails/:id', component: ProductDetailsComponent},
  {path: 'windowDetails/:id', component: WindowDetailsComponent}
];



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/app.routes.ts